








import { Component, Vue } from 'vue-property-decorator';
import { FitLoading, FitDialog, FitToast } from '@/fit-components';


@Component({
  components: {
    FitLoading,
    FitDialog,
    FitToast,
  },
})
export default class App extends Vue {
  public created() {
    return;
  }
}
